import { useEffect, useRef, useState } from "react";

const stats = [
  { value: 500, suffix: "+", label: "zrealizowanych zleceń" },
  { value: 5, suffix: ".0", label: "średnia ocena klientów" },
  { value: 3, suffix: "h", label: "średni czas reakcji" },
  { value: 50, suffix: "km", label: "zasięg od centrum Poznania" },
];

const AnimatedCounter = ({ target, suffix }: { target: number; suffix: string }) => {
  const [count, setCount] = useState(0);
  const ref = useRef<HTMLDivElement>(null);
  const hasAnimated = useRef(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !hasAnimated.current) {
          hasAnimated.current = true;
          const duration = 1500;
          const steps = 40;
          const increment = target / steps;
          let current = 0;
          const timer = setInterval(() => {
            current += increment;
            if (current >= target) {
              setCount(target);
              clearInterval(timer);
            } else {
              setCount(Math.floor(current));
            }
          }, duration / steps);
        }
      },
      { threshold: 0.5 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [target]);

  return (
    <div ref={ref} className="text-3xl md:text-4xl font-heading font-bold text-primary-foreground">
      {count}{suffix}
    </div>
  );
};

const StatsSection = () => (
  <section className="py-14 bg-gradient-to-r from-foreground via-foreground/95 to-foreground" aria-label="Statystyki Pan Fixer">
    <div className="container max-w-6xl mx-auto px-6">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
        {stats.map((stat) => (
          <div key={stat.label} className="text-center">
            <AnimatedCounter target={stat.value} suffix={stat.suffix} />
            <p className="text-primary-foreground/50 text-sm mt-1">{stat.label}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default StatsSection;
